/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';
import styles from './MandatoryModal.scss';

class MandatoryModal extends React.PureComponent {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        isOneWay: PropTypes.bool.isRequired,
        onReturnToQuestion: PropTypes.func.isRequired,
        onConfirmNext: PropTypes.func.isRequired,
    };

    handleDialogKeyDown = (e) => {
        const { onReturnToQuestion } = this.props;
        if (e.key === 'Escape') {
            onReturnToQuestion();
        }
    };

    render() {
        const { show, isOneWay, onReturnToQuestion, onConfirmNext } = this.props;

        if (!show) return null;

        return (
            <div className={styles.mandatoryModalOverlay}>
                <div
                    className={styles.mandatoryModal}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="mandatory-modal-title"
                    tabIndex="-1"
                    onKeyDown={this.handleDialogKeyDown}
                >
                    <div className={styles.mandatoryModalHeader}>
                        <div className={styles.mandatoryModalHeaderFrame}>
                            <h3 id="mandatory-modal-title" className={styles.mandatoryModalTitle}>
                                {t('mandatory.modal.title')}
                            </h3>
                        </div>
                        <button
                            type="button"
                            aria-label="Close dialog"
                            className={styles.mandatoryModalCloseIcon}
                            onClick={onReturnToQuestion}
                        >
                            <i className="fa fa-times" aria-hidden="true">
                                <span />
                                <span />
                            </i>
                        </button>
                    </div>

                    <div className={styles.mandatoryModalBody}>
                        <p className={styles.mandatoryModalText}>
                            {
                                isOneWay ?
                                    t('mandatory.modal.oneway.text')
                                    : <span dangerouslySetInnerHTML={{ __html: t('mandatory.modal.text') }} />
                            }
                        </p>
                    </div>

                    <div className={styles.mandatoryModalActions}>
                        {
                            !isOneWay && (
                                <button
                                    type="button"
                                    className={styles.textButton}
                                    onClick={onConfirmNext}
                                >
                                    <span className={styles.textButtonContent}>{t('mandatory.button.nextquestion')}</span>
                                </button>
                            )
                        }

                        <button
                            type="button"
                            className={styles.primaryButton}
                            onClick={onReturnToQuestion}
                        >
                            <span className={styles.primaryButtonContent}>{t('mandatory.button.return')}</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default MandatoryModal;
